import type { ModalActionHandler } from './modalActionTypes';
import { assignJob, getFreePopulation, MAX_QUARRYMEN } from '../map/settlement';
import { getSettlement } from './settlementActionUtils';

export const hireQuarrymanAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement) return false;
    const freePop = getFreePopulation(settlement);
    const cap = MAX_QUARRYMEN * settlement.buildings.quarry.qty;
    if (settlement.jobs.quarrymen >= cap || freePop <= 0) return false;
    if (!assignJob(settlement, 'quarrymen')) return false;
    return true;
};
